import { config } from '@/config/environment'

interface BetaRequestData {
  name: string
  email: string
  company: string
  use_case: string
}

interface BetaRequestResponse {
  success: boolean
  message: string
  request_id?: string
  emails_sent?: {
    notification_sent: boolean
    confirmation_sent: boolean
  }
  timestamp: number
}

export async function submitBetaRequest(data: BetaRequestData): Promise<BetaRequestResponse> {
  const response = await fetch(`${config.apiUrl}/beta/request-access`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      name: data.name,
      email: data.email,
      company: data.company,
      use_case: data.use_case
    })
  })

  if (!response.ok) {
    // Handle rate limiting
    if (response.status === 429) {
      throw new Error('Too many requests. Please try again later.')
    }
    
    // Handle validation errors
    if (response.status === 422) {
      const error = await response.json()
      throw new Error(error.detail?.[0]?.msg || 'Please check your information and try again.')
    }
    
    throw new Error('Failed to submit request. Please try again.')
  }

  return response.json()
}